<template>
  <div class="form-check text-center">
    <input
      type="checkbox"
      :class="value.class"
      class="form-check-input"
      @change="click"
      :checked="value.selection.indexOf(value.id) >= 0"
    />
  </div>
</template>

<script>
export default {
  name: 'checkboxTd',
  props: ['value'],

  methods: {
    click() {
      this.value.action(this.value.id);
    },
  },
};
</script>

<style scoped>
</style>
